import React from 'react'

const Question = (props) => (
  <section className={`s-question ${ props.styleName || "" }`} id={ props.id || "" }>
      {props.children}
  </section>
)
export default Question
